import React from 'react';
import { useEffect, useState } from 'react';
import CareersHero from './sections/CareersHero';
import JobListings from './sections/JobListings';
import CareersCTA from './sections/CareersCTA';
import { Job } from '../../types/jobs';
import { fetchJobs } from '../../lib/careers';

const CareersPage = () => {
  const [jobs, setJobs] = useState<Job[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadJobs = async () => {
      try {
        setLoading(true);
        const jobsData = await fetchJobs();
        setJobs(jobsData);
      } catch (err) {
        setError('Failed to load jobs. Please try again later.');
        console.error('Error loading jobs:', err);
      } finally {
        setLoading(false);
      }
    };

    loadJobs();
  }, []);

  return (
    <main className="min-h-screen bg-black">
      <CareersHero />
      <JobListings jobs={jobs} loading={loading} error={error} />
      <CareersCTA />
    </main>
  );
};

export default CareersPage;